import styled from "styled-components/macro";

import { AccordionItem } from "components/AccordionItem";
import type { ThemeProps } from "models/styles/theme";
import { CssButton, CssFlex, CssGrid, CssIcon } from "styles/helpers/layout";
import { calculateRem } from "styles/mixins/calculateRem";

import { AccessibilityMenuButton } from "components/AccessibilityMenuButton/AccessibilityMenuButton";
import { SvgIconReact } from "components/SvgIconReact";

export const StyledNavigationMenu = styled.nav<ThemeProps>`
  max-height: 100%;
  overflow-y: auto;
`;

export const StyledNavigationItemGroup = styled(AccordionItem)`
  .tab-label .tab-title .tab-title-text {
    font-size: ${(props: ThemeProps) => props.theme.font.size._16};
    letter-spacing: initial;
  }
  .tab-label {
    padding: 1rem 1.5rem;
  }
  .tab-content {
    padding-left: 0.5rem;
  }
`;

export const StyledOnboardingButton = styled(CssButton)<ThemeProps>`
  color: ${(props: ThemeProps) => props.theme.palette.neutral.black};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};

  :hover {
    color: ${(props: ThemeProps) => props.theme.palette.neutral._600};
    font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};
  }
`;

export const StyledNavigationContainer = styled(CssGrid)`
  background-color: ${(props: ThemeProps) => props.theme.palette.neutral.white};
  border-right: 1px solid ${(props: ThemeProps) => props.theme.palette.neutral._700};
  padding: 1rem 0.5rem;

  width: 300px;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;

  row-gap: 1rem;
`;

export const StyledButton = styled(CssButton)<ThemeProps>`
  color: ${(props: ThemeProps) => props.theme.palette.neutral.black};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};
  font-size: ${(props: ThemeProps) => props.theme.font.size._14};
  margin-bottom: 1.5rem;
  margin-left: 1rem;
  :hover {
    color: ${(props: ThemeProps) => props.theme.palette.neutral._600};
    font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};
  }

  .content {
    display: grid;
    grid-template-columns: ${calculateRem(23)} 1fr;
    column-gap: 1rem;
    align-items: center;
    justify-items: left;
  }
`;

export const StyledProfileButton = styled(CssFlex)<ThemeProps>`
  padding-top: 1rem;
  cursor: pointer;
  color: ${(props: ThemeProps) => props.theme.palette.primary.brand};
  border-radius: 3px;
  border-top: 1px solid ${(props: ThemeProps) => props.theme.palette.neutral._700};
  font-size: ${(props: ThemeProps) => props.theme.font.size._16};
  p {
    color: ${(props: ThemeProps) => props.theme.palette.neutral.black};
  }
`;

export const StyledLogo = styled(SvgIconReact)`
  height: 2rem;
  width: 12rem;
  margin-left: 1.5rem;
`;

export const StyledLogoContainer = styled(CssFlex)`
  padding-bottom: 0.5rem;
`;

export const StyledNavigationBottomContainer = styled(CssFlex)`
  flex-direction: column;
  justify-content: space-between;
`;

export const StyledNavigationItemName = styled(CssGrid)`
  grid-template-columns: ${calculateRem(23)} 1fr auto;
  column-gap: 1rem;
  font-size: ${(props: ThemeProps) => props.theme.font.size._14};
  align-items: center;
`;

export const StyledOrphanNavigationItemName = styled(StyledNavigationItemName)`
  padding: 1rem 0.5rem;
`;

export const StyledIcon = styled(CssIcon)`
  font-size: ${(props: ThemeProps) => props.theme.font.size._16};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};

  align-self: center;
  justify-self: center;
`;

export const StyledDropdownIcon = styled(CssIcon)`
  color: ${(props: ThemeProps) => props.theme.palette.neutral._700};
  pointer-events: none;
  transition: transform 0.35s ease;

  .accordion-expanded & {
    transform: rotate(180deg);
  }
`;

export const StyledAccessibilityMenuButton = styled(AccessibilityMenuButton)`
  margin: 0 0 1.5rem 1rem;

  .content {
    display: grid;
    grid-template-columns: ${calculateRem(23)} 1fr;
    column-gap: 1rem;
    align-items: center;
    justify-items: left;

    > :first-child
    {
      align-self: center;
      justify-self: center;
    }
  }
`;
